import { Languages } from "../types";
import { CommonPagesDescriptions } from "./types";

const DescriptionsEnUs: CommonPagesDescriptions = {
    ACTIVE_STATUS: "Active",
    INACTIVE_STATUS: "Inactive",
    YES: "Yes",
    NO: "No",
    SEARCH: "Search",
    ACTIONS: {
        EDIT: "Edit",
        VIEW: "View",
    },
    FORM: {
        REQUIRED_FIELD: (fieldName: string) => `${fieldName} is required`,
        UNKNOWN_ERROR: "An unknown error ocurred, please contact suport",
        INVALID_CREDNTIALS: "Invalid credentials",
    },
}

const DescriptionsEsUs: CommonPagesDescriptions = {
    ACTIVE_STATUS: "Activo",
    INACTIVE_STATUS: "Inactivo",
    YES: "Si",
    NO: "No",
    SEARCH: "Buscar",
    ACTIONS: {
        EDIT: "Editar",
        VIEW: "Ver",
    },
    FORM: {
        REQUIRED_FIELD: (fieldName: string) => `${fieldName} es requerido`,
        UNKNOWN_ERROR: "Ha ocurrido un error al procesar la petición, contactar a soporte",
        INVALID_CREDNTIALS: "Credenciales inválidas",
    },
}

const commonPageDictionary = {}
commonPageDictionary[Languages.ENGLISH_US] = DescriptionsEnUs
commonPageDictionary[Languages.SPANISH_US] = DescriptionsEsUs

export const getCommonPagesDescriptions = (systemLang: Languages): CommonPagesDescriptions => (
    commonPageDictionary[systemLang]
)